//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'; 
export default {
  name: 'editBag',
  components: {
  },
  data () {
    return {
      id:0,
      order_no:'',
      code:'',
      submitStatus:false,
    }
  },
  created(){
    this.config();
  },
  mounted(){
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  
  },
  methods:{
    copy(val){
        this.$func.copy(val,event);
    },
    scanQRCode(){
        let that = this;
        wx.ready(()=> {
            wx.scanQRCode({
            needResult: 1,
            scanType: ['qrCode'],
            success: function (res) {
                setTimeout(()=>{
                    that.order_no = res.resultStr;
                },300);
            }
            })
        });
        wx.error((res)=> {
            console.log(res)
            // alert(res.errMsg);
        })
    },  
    scanBrCode(){
        let that = this;
        wx.ready(()=> {
            wx.scanQRCode({
            needResult: 1,
            scanType: ['barCode'],
            success: function (res) {
                setTimeout(()=>{
                  that.code = res.resultStr.split(',')[1];
                },300);
            }
            })
        });
        wx.error((res)=> {
            console.log(res)
            // alert(res.errMsg);
        })
    },  
    config(){
        let url = (window.location.href).split('#');
        if(url[0].indexOf('?') != '-1'){
            url = url[0].split('?');
        }
        this.$api.wxSign({url:url[0]}).then((res)=>{
            if(res){
                wx.config({
                    debug: false, 
                    appId: res.data.appId,
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature:res.data.signature,
                    jsApiList: [
                        "scanQRCode"
                    ]
                });
            }
        })
    },
    submit(){
      let that = this;
      if(!this.order_no){
        that.$func.showToast('订单号无效');
        return ;
      }
      if(!this.code){
        that.$func.showToast('扎带码无效');
        return ;
      }
      this.$api.editBag({order_no:this.order_no,code:this.code}).then((res)=>{
        if(res){
          that.$func.showToast('修改成功');
          that.code = '';
          that.order_no = '';
          wx.ready(function () {
              let media = document.getElementById("musicBox");
              media.src = "https://wash.uunbiot.com/uploads/default/operate.mp3"
              media.play();
          });
        } 
      })  
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/editBag.vue